@if(beginRender){
<section class="dynamic-tabs-container"  style="position: relative;">
  @if(filterSchema){
  <div class="layout-container">
    <div class="left-panel">
      <app-search-container [dynamicFormArray]="filterSchema" [props]="props"
        [DataTableSchema]="tabConfig[selectedIndex]?.inputs?.DataTableSchema"
        class="app-search-container"></app-search-container>
    </div>
    <div class="right-panel">
      @if(title){
      <div class="header-row">
        <header class="data-table-title">{{title |camelCase}}</header>
      </div>
      }
      <ng-container [ngTemplateOutlet]="tab"></ng-container>
    </div>
  </div>
  }@else{ 
  <ng-container [ngTemplateOutlet]="tab"></ng-container>
  }
  @if(isLoading){
  <app-spinner [spinnerName]="spinnerName"></app-spinner>
  }
</section>
}
<ng-template #tab>
  <mat-tab-group mat-align-tabs="start" [mat-stretch-tabs]="props.isTabStretch"
    (selectedTabChange)="onTabChange($event)" [(selectedIndex)]="selectedIndex"
    [preserveContent]="true">
      @for(tab of tabConfig; track idx; let idx = $index){
        <mat-tab [label]="tab['label'] | camelCase" class="dynamic-tab">
          <ng-template matTabContent>
            @if(tab['type'] === TabType['List']){
              @if(tab['component'] && tab['inputs']?.['forSection']){
                <ng-container *ngComponentOutlet="tab['component']; inputs: tab['inputs']" />
              }@else{
                <app-dynamic-data-table [props]="tab['inputs']['props']" [DataTableSchema]="tab['inputs']['DataTableSchema']" [dataInput]="tab['inputs']['DataTableSchema'].dataSource.length>0?tab['inputs']['DataTableSchema'].dataSource:[]"></app-dynamic-data-table>
              }
            }@else{
              <ng-container *ngComponentOutlet="tab['component']; inputs: tab['inputs']" />
            }
            @if(tab['tabInfoText']){
              <div class="tab-info-text">
                <span>
                  <i class="fa-solid fa-circle-info tab-info-icon"></i>
                  <span class="tab-info">{{ tab["tabInfoText"]}}</span>
                </span>
              </div>
            }
          </ng-template>
        </mat-tab>
      }
  </mat-tab-group>
</ng-template>